<template>
  <transition name="lightbox">
    <div class="lightbox">
      <div class="lightbox-mask">
        <div
          class="lightbox-photo"
          v-if="photoUrl"
          v-bind:style="{ backgroundImage: 'url(' + photoUrl + ')' }">
        </div>
        <div class="lightbox-close-button icon-cross" @click="$emit('close')"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'lightbox',
  props: ['photoUrl']
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity .3s ease;
  z-index: 100;
}

.lightbox-mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .5);
}

.lightbox-photo {
  position: absolute;
  top: 50px;
  bottom: 100px;
  left: 50px;
  right: 50px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.lightbox-close-button {
  font-size: 20px;
  position: absolute;
  right: 20px;
  top: 20px;
  color: silver;
  cursor: pointer;
}

.lightbox-close-button:hover {
  color: white;
  transition: color .3s ease;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.lightbox-enter {
  opacity: 0;
}

.lightbox-leave-active {
  opacity: 0;
}

.lightbox-enter .lightbox,
.lightbox-leave-active .lightbox {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// lightbox.vue?41820d65